angular.module('FmsApp').factory("SatelliteProcessedDataListFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/satellite/satelliteprocesseddata/');
}]);
angular.module('FmsApp').factory("FieldPlotCropCountFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/fieldplotcrop/count/:season');
}]);
